import { createActions, createReducer } from 'reduxsauce';
import { IRequestConfig } from '../../models/Axios';

export const { Types, Creators } = createActions({
  setEnterpriseVips: [],
});

const INITIAL_STATE: Array<string> = [];

const setEnterpriseVips = (state = INITIAL_STATE, action: IRequestConfig<Array<string>>) => (
  action.data
);

export default createReducer(INITIAL_STATE, {
  [Types.SET_ENTERPRISE_VIPS as any]: setEnterpriseVips,
});
